module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-28.1d61a0b7.png";